export enum Osasc2Policy {
    continuousPositiveAirwayPressure = 'CPAP',
    mandibulairRepositieApparaat = 'MRA',
    sleepPositionTrainer = 'SPT',
}
